import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Card } from '@/components/ui/card';
import { fmtDateTimeMX } from '@/lib/format';

const ACTION_LABEL = {
  login: 'Inicio de sesión', logout: 'Cierre de sesión', create: 'Creación',
  update: 'Modificación', delete: 'Eliminación', lock: 'Bloqueo de periodo',
  unlock: 'Reapertura', upload: 'Subida de archivo', update_iva_rate: 'Cambio tasa IVA',
  update_period: 'Actualización periodo', change_password: 'Cambio contraseña',
};

export default function History() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get('/audit').then(r => setLogs(r.data)); }, []);

  return (
    <div className="space-y-5">
      <div>
        <h2 className="font-display text-2xl font-bold tracking-tight">Historial</h2>
        <p className="text-xs text-muted-foreground mt-0.5">Registro completo de accesos y cambios</p>
      </div>
      {logs.length === 0 ? (
        <Card className="p-8 text-center border-dashed"><p className="text-sm text-muted-foreground">Sin registros aún.</p></Card>
      ) : (
        <div className="space-y-2" data-testid="history-list">
          {logs.map(l => (
            <Card key={l.id} className="p-3 border-border rounded-lg" data-testid={`log-${l.id}`}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="text-sm font-medium">{ACTION_LABEL[l.action] || l.action} · <span className="text-muted-foreground">{l.entity}</span></p>
                  <p className="text-xs text-muted-foreground">{l.user_email}</p>
                  {l.meta && Object.keys(l.meta).length > 0 && (
                    <p className="text-[11px] text-muted-foreground mt-1 truncate">{JSON.stringify(l.meta)}</p>
                  )}
                </div>
                <p className="text-[10px] text-muted-foreground whitespace-nowrap">{fmtDateTimeMX(l.at)}</p>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
